import { Box } from "@mui/material";
import UiCard from "components/base/UiCard";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import { worksheetSellingGrid } from "./worksheetStyles";

export default function WorksheetColumnHeaders() {
  return (
    <UiCard
      variant="section"
      sx={{
        display: { xs: "none", lg: "block" },
        px: 1.5,
        py: 0.75,
        mb: 0.5,
        bgcolor: draftColors.surfaceTableHeader,
      }}
    >
      <Box sx={worksheetSellingGrid} aria-label="Product column headings">
        {[
          "Item Name",
          "Quantity",
          "Unit",
          "Unit Price",
          "Overhead %",
          "Indirect %",
          "Costs",
          "Profit",
          "Margin %",
          "Discount",
          "Total",
          "Optional",
        ].map((label, index) => (
          <Box
            key={label}
            sx={{
              fontSize: 11,
              fontWeight: 600,
              color: draftColors.textLabel,
              whiteSpace: "nowrap",
              textAlign:
                label === "Optional" ? "center" : index === 0 || index === 2 ? "left" : "right",
              pl: index === 0 ? 4 : index === 2 ? 1 : 0,
              pr: index > 0 && index !== 2 && label !== "Optional" ? 1 : 0,
            }}
          >
            {label}
          </Box>
        ))}
        <Box />
      </Box>
    </UiCard>
  );
}
